import { AllActivityTypesField, TableInlines, TableInlineColumn } from 'components';
import { DecimalField, useForm, useOnFieldChange } from '@ff-it/form';
import { ReactElement } from 'react';

import { SupplierField } from 'modules/supplier/supplier/components';

const initialValues = {
  type: null,
  activty: null,
  supplier: null,
  agency_amount: null,
};

function TypeSupplierField({ name }: { name: string }): ReactElement {
  const form = useForm();
  const type = useOnFieldChange(`${name}.type`, (value) => {
    if (value && value !== form.getState().values[`${name}.supplier`]?.product.type) {
      form.change(`${name}.supplier`, null);
    }
  });
  return (
    <SupplierField
      name={`${name}.supplier`}
      type={type}
      disabled={!type}
      placeholder="Supplier"
      className="mb-0"
      required
    />
  );
}

const columns: TableInlineColumn[] = [
  {
    key: 'type',
    content: 'Type',
    render: ({ name }) => <AllActivityTypesField name={`${name}.type`} placeholder="Type" className="mb-0" required />,
  },
  {
    key: 'supplier',
    content: 'Supplier',
    render: ({ name }) => <TypeSupplierField name={name} />,
  },
  {
    key: 'agency_amount',
    content: 'Amount',
    render: ({ name }) => <DecimalField name={`${name}.agency_amount`} className="mb-0" required />,
  },
];

export function ExternalSums(): ReactElement {
  return <TableInlines name="sums" columns={columns} initialValues={initialValues} />;
}
